import { RestService } from './_services/helper/rest-service';
import { BaseService } from './_services/base.service';
import { ConfigService } from './_services/config.service';
import { LoggerService } from './core/logger/global-logger.service';
import { ApplicationInsightsService } from './_services/applicationInsights.service';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { LocalCacheService } from './core/local-cache/local-cache.service';
import { LocalCacheModule } from './core/local-cache/local-cache.module';
import { AuthenticationGuard} from './core/auth/guards/authentication-gaurd';
import { LoginComponent } from './login/login.component';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { Adal5Service, Adal5HTTPService } from 'adal-angular5';
import { AppComponent } from './app.component';
import { Http, Response, Headers, HttpModule , RequestOptions} from '@angular/http';
import { BaseEndpoint } from './app.constants';
import { ToasterModule } from 'angular2-toaster';
import { ToasterService, ToasterConfig } from 'angular2-toaster';
import { SubheaderHandlerService } from './shared/services/subheader-handler.service';
import { TranslateModule, TranslateLoader, TranslateService, TranslateModuleConfig, TranslateParser } from '@ngx-translate/core';
import { TranslateICUParser } from 'ngx-translate-parser-plural-select';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient , HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule  } from '@angular/forms';
import { SharedModule } from './shared/shared.module';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NgIdleModule } from '@ng-idle/core';
import { SharedCallsService } from './shared/services/shared-calls.service';
import { TimeoutHandlerService } from './shared/services/timeout-handler.service';
// Views
import { HomeComponent } from './components/home/home.component';
import { MapRefiningComponent } from './components/map/map.component';
// Custom Components
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { FooterComponent } from './components/shared/layout/footer/footer.component';
import { HeaderComponent } from './components/shared/layout/header/header.component';
import { SideBarComponent } from './components/shared/layout/side-bar/side-bar.component';
import { MapTileComponent } from './components/map-tile/map-tile.component';
import { ModalPdfComponent } from './components/shared/modal-pdf/modal-pdf.component';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MapPopoverComponent } from './components/shared/map-popover/map-popover.component';
import { PopoverModule } from 'ngx-popover';
import { ZoomControlsComponent } from './components/shared/zoom-controls/zoom-controls.component';
import { MapBreadcrumbComponent } from './breadcrumb/map-breadcrumb.component';
import { McBreadcrumbsModule } from 'ngx-breadcrumbs';
import { environment } from '../environments/environment';
import { BaseComponent } from './components/shared/baseComponent';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { HelpComponent } from './components/shared/help/help.component';
import { LoggerComponent } from './core/logger/logger.component';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component';
import { SubHeaderComponent } from './shared/components/sub-header/sub-header.component';
import { SubHeaderLeftSectionComponent } from './shared/components/sub-header/left-section/left-section.component';
import { SubHeaderRightSectionComponent } from './shared/components/sub-header/right-section/right-section.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { UsersListComponent } from './users/users-list.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { AddEditUsersComponent } from './users/add-edit-users/add-edit-users.component';
import { UsersGridService } from './users/users-grid.service';
import { UsersService } from './users/_services/users.service';
import { GlobalErrorHandlerService } from './core/auth/global-error-handler.service';
import { ExtendedHttpService } from './core/auth/extended-http.service';
import { AuthorizationAdminGuard } from './core/authorization/authorization-admin-gaurd';
import { AuthorizationMarketerGuard } from './core/authorization/authorization-marketer-guard';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MapRefiningComponent,
    PdfViewerComponent,
    FooterComponent,
    HeaderComponent,
    SideBarComponent,
    MapTileComponent,
    LoginComponent,
    ModalPdfComponent,
    MapPopoverComponent,
    ZoomControlsComponent,
    MapBreadcrumbComponent,
    BaseComponent,
    HelpComponent,
    LoggerComponent,
    BreadcrumbComponent,
    SubHeaderComponent,
    SubHeaderLeftSectionComponent,
    SubHeaderRightSectionComponent,
    PageNotFoundComponent,
    UsersListComponent,
    AddEditUsersComponent
  ],
  imports: [
    HttpModule,
    BrowserModule,
    PopoverModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.threeBounce,
      backdropBackgroundColour: 'rgba(0,0,0,0.6)',
      backdropBorderRadius: '4px',
      primaryColour: '#ffffff',
      secondaryColour: '#ffffff',
      tertiaryColour: '#ffffff'
    }),
    NgbModule.forRoot(),
    AppRoutingModule,
    McBreadcrumbsModule.forRoot(),
    AngularFontAwesomeModule,
    NoopAnimationsModule,
    ToasterModule.forRoot(),
    LocalCacheModule.forRoot({
      mode: 'session',
      namespace: 'dsi.vt'
    }),
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient],
      },
      parser: {
        provide: TranslateParser,
        useClass: TranslateICUParser
      }
    }),
    GridModule,
    DropDownsModule,
    NgIdleModule.forRoot()
  ],
  providers: [
    Adal5Service,
    {
      provide: Adal5HTTPService,
      useFactory: Adal5HTTPService.factory,
      deps: [Http, Adal5Service]
    },
    GlobalErrorHandlerService,
    {provide: Http, useClass: ExtendedHttpService },
    AuthenticationGuard,
    AuthorizationAdminGuard,
    AuthorizationMarketerGuard,
    ConfigService,
    RestService,
    BaseService,
    ApplicationInsightsService,
    { provide: BaseEndpoint, useValue: environment.endPoint },
    LoggerService,
    ToasterService,
    SubheaderHandlerService,
    SharedCallsService,
    LocalCacheService,
    NgbActiveModal,
    UsersService,
    UsersGridService,
    NgIdleModule,
    TimeoutHandlerService
  ],
  entryComponents: [
    AddEditUsersComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/app.module.ts